type Obj = Record<string, unknown> | Record<string, unknown>[];


export type FetchResponse = { success: boolean; data?: Obj ; error?: string| any };



export async function POST_REQUEST( url: string, body:Record<string, unknown>, options?: Record<string, unknown> ): Promise<FetchResponse> {
  try {
    const res = await fetch(`/api/${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      ...options,
    });
    const data: Record<string, unknown> = await res.json();
    if ( typeof data != "string"&& 'error' in data && data.error != null)
      return { success: false , error : data.error }
    else 
      return { success: true, data };
  } catch (error: any) {
    return { success: false, error: error?.message ?? "Unexpected Error" };
  }
}

export async function GET_REQUEST( url: string, options?: Record<string, unknown> ): Promise<FetchResponse> {
  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/${url}`, options);
    const data = await res.json();
    return { success: true, data: data };
  } catch (error: any) {
    return { success: false, error: error?.message ?? "Unexpected Error" };
  }
}

